"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIllustration = _interopRequireDefault(require("../withIllustration"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IllustrationError = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 720 297",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      id: "Page-1",
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        id: "illustrasjoner-spot",
        transform: "translate(-670.000000, -125.000000)",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          id: "Group-6",
          transform: "translate(670.000000, 125.000000)",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
            id: "Group-5",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M21.6000003,289.200004 L21.6000003,225.821749 C21.6000003,213.697262 26.6795621,202.069218 35.7199321,193.495973 L62.0230155,168.55433 C71.0640043,159.981085 76.1429473,148.353041 76.1429473,136.228553 L76.1429473,101.690447 C76.1429473,89.5659594 81.222509,77.9379155 90.2634978,69.3646706 L149.291978,13.3897374 C158.333586,4.81649237 170.595322,0 183.381784,0 L387.890299,0 C400.676142,0 412.939117,4.81649237 421.979487,13.3897374 L491.916433,79.7088942 C500.95804,88.2821392 513.220396,93.0986315 526.006238,93.0986315 L609.451762,93.0986315 C622.237605,93.0986315 634.49996,97.9151239 643.540949,106.488369 L653.481025,115.913986 C662.521395,124.487231 667.600956,136.115275 667.600956,148.239762 L667.600956,167.261224 C667.600956,179.385712 672.679899,191.013755 681.721507,199.587 L683.47946,201.253986 C692.521067,209.82785 697.60001,221.455894 697.60001,233.579762 L697.60001,289.200004 L21.6000003,289.200004 Z",
              id: "Fill-1",
              className: "fill-primary",
              fill: "#E0E9FB",
              opacity: "0.1",
              transform: "translate(359.600005, 144.600002) scale(-1, 1) translate(-359.600005, -144.600002) "
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              id: "Group-3",
              transform: "translate(50.200001, 98.400001)",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                id: "Group-Copy-2",
                transform: "translate(34.800001, 0.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M47.2000007,0 C66.8613381,0 82.8000012,16.0282062 82.8000012,35.8000005 C82.8000012,38.9512428 82.395124,42.0073897 81.6348276,44.9187054 C89.5513793,53.3593681 94.4000014,64.7134564 94.4000014,77.2000012 C94.4000014,103.267842 73.2678413,124.400002 47.2000007,124.400002 C21.1321601,124.400002 0,103.267842 0,77.2000012 C0,64.7134564 4.84862208,53.3593681 12.7658159,44.9177864 C12.0048774,42.0073897 11.6000002,38.9512428 11.6000002,35.8000005 C11.6000002,16.0282062 27.5386633,0 47.2000007,0 Z",
                  id: "Combined-Shape-Copy-3",
                  className: "fill-primary-opa50",
                  fill: "#779DED"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M48.8000007,68.400001 C50.1254841,68.400001 51.2000008,69.4745176 51.2000008,70.8000011 L51.1999852,90.599001 L62.2740575,75.4013981 C63.0488546,74.3380039 64.537755,74.1015026 65.6039278,74.8724717 C66.6651589,75.6398674 66.9033596,77.1222623 66.1359639,78.1834934 C66.1342988,78.1857961 66.1326295,78.1880957 66.1309562,78.1903924 L51.3259442,98.509989 C51.2863285,98.5643608 51.2448459,98.6165709 51.2016483,98.666595 L51.2000008,146.400002 C51.2000008,147.725486 50.1254841,148.800002 48.8000007,148.800002 C47.4745173,148.800002 46.4000007,147.725486 46.4000007,146.400002 L46.4001624,104.033614 C46.3462336,103.988543 46.2938232,103.940726 46.243116,103.890162 L32.7787355,90.4640123 C31.8502691,89.5381823 31.848132,88.034978 32.7739621,87.1065117 C32.7760736,87.1043942 32.7781891,87.1022806 32.7803087,87.1001711 C33.7141896,86.1706822 35.223874,86.1713883 36.1568852,87.1017502 L46.3999852,97.315001 L46.4000007,70.8000011 C46.4000007,69.4745176 47.4745173,68.400001 48.8000007,68.400001 Z",
                  id: "Combined-Shape-Copy-4",
                  fill: "#091E43"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                id: "Group-Copy-3",
                transform: "translate(0.000000, 60.800001)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M34.8000005,0 C49.2960713,0 61.0474585,11.8536573 61.0474585,26.4758846 C61.0474585,28.8064372 60.7489341,31.0666588 60.1883524,33.219765 C66.0254249,39.462512 69.600001,47.8591562 69.600001,57.0932484 C69.600001,76.3717157 54.0195101,92.0000014 34.8000005,92.0000014 C15.5804909,92.0000014 0,76.3717157 0,57.0932484 C0,47.8591562 3.57457612,39.462512 9.411459,33.2196108 C8.85106692,31.0666588 8.5525425,28.8064372 8.5525425,26.4758846 C8.5525425,11.8536573 20.3039297,0 34.8000005,0 Z",
                  id: "Combined-Shape-Copy-3",
                  className: "fill-primary",
                  fill: "#1657E2"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M36.0042324,50.4000008 C36.9876399,50.4000008 37.7848491,51.19721 37.7848491,52.1806174 L37.7839476,66.7690008 L45.9989598,55.5652127 C46.5758864,54.7782711 47.6790917,54.6030418 48.4714624,55.1724889 C49.2542012,55.7350139 49.4327198,56.8255657 48.8701948,57.6083045 C48.8669789,57.6127792 48.863742,57.6172387 48.8604839,57.6216827 L37.8802828,72.5989369 L37.7839476,72.7180008 L37.7848491,107.902473 C37.7848491,108.88588 36.9876399,109.68309 36.0042324,109.68309 C35.020825,109.68309 34.2236158,108.88588 34.2236158,107.902473 L34.2234737,76.67434 C34.1835658,76.6411505 34.144767,76.6059469 34.1072121,76.5687294 L24.117685,66.6689473 C23.4330747,65.9904874 23.4280887,64.8855008 24.1065485,64.2008904 L24.1188449,64.1886056 L24.1188449,64.1886056 C24.8129583,63.5020136 25.930543,63.5025363 26.6240139,64.1897771 L34.2229476,71.7200008 L34.2236158,52.1806174 C34.2236158,51.19721 35.020825,50.4000008 36.0042324,50.4000008 Z",
                  id: "Combined-Shape-Copy-4",
                  fill: "#091E43"
                })]
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              id: "Group-3-Copy",
              transform: "translate(609.400010, 186.700002) scale(-1, 1) translate(-609.400010, -186.700002) translate(544.400010, 101.200002)",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                id: "Group-Copy-2",
                transform: "translate(34.800001, 0.000000)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M47.2000007,0 C66.8613381,0 82.8000012,16.0282062 82.8000012,35.8000005 C82.8000012,38.9512428 82.395124,42.0073897 81.6348276,44.9187054 C89.5513793,53.3593681 94.4000014,64.7134564 94.4000014,77.2000012 C94.4000014,103.267842 73.2678413,124.400002 47.2000007,124.400002 C21.1321601,124.400002 0,103.267842 0,77.2000012 C0,64.7134564 4.84862208,53.3593681 12.7658159,44.9177864 C12.0048774,42.0073897 11.6000002,38.9512428 11.6000002,35.8000005 C11.6000002,16.0282062 27.5386633,0 47.2000007,0 Z",
                  id: "Combined-Shape-Copy-3",
                  className: "fill-primary-opa50",
                  fill: "#779DED"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M48.8000007,68.400001 C50.1254841,68.400001 51.2000008,69.4745176 51.2000008,70.8000011 L51.1999852,90.599001 L62.2740575,75.4013981 C63.0488546,74.3380039 64.537755,74.1015026 65.6039278,74.8724717 C66.6651589,75.6398674 66.9033596,77.1222623 66.1359639,78.1834934 C66.1342988,78.1857961 66.1326295,78.1880957 66.1309562,78.1903924 L51.3259442,98.509989 C51.2863285,98.5643608 51.2448459,98.6165709 51.2016483,98.666595 L51.2000008,146.400002 C51.2000008,147.725486 50.1254841,148.800002 48.8000007,148.800002 C47.4745173,148.800002 46.4000007,147.725486 46.4000007,146.400002 L46.4001624,104.033614 C46.3462336,103.988543 46.2938232,103.940726 46.243116,103.890162 L32.7787355,90.4640123 C31.8502691,89.5381823 31.848132,88.034978 32.7739621,87.1065117 C32.7760736,87.1043942 32.7781891,87.1022806 32.7803087,87.1001711 C33.7141896,86.1706822 35.223874,86.1713883 36.1568852,87.1017502 L46.3999852,97.315001 L46.4000007,70.8000011 C46.4000007,69.4745176 47.4745173,68.400001 48.8000007,68.400001 Z",
                  id: "Combined-Shape-Copy-4",
                  fill: "#091E43"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                id: "Group-Copy-3",
                transform: "translate(0.000000, 60.800001)",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M34.8000005,0 C49.2960713,0 61.0474585,11.8536573 61.0474585,26.4758846 C61.0474585,28.8064372 60.7489341,31.0666588 60.1883524,33.219765 C66.0254249,39.462512 69.600001,47.8591562 69.600001,57.0932484 C69.600001,76.3717157 54.0195101,92.0000014 34.8000005,92.0000014 C15.5804909,92.0000014 0,76.3717157 0,57.0932484 C0,47.8591562 3.57457612,39.462512 9.411459,33.2196108 C8.85106692,31.0666588 8.5525425,28.8064372 8.5525425,26.4758846 C8.5525425,11.8536573 20.3039297,0 34.8000005,0 Z",
                  id: "Combined-Shape-Copy-3",
                  className: "fill-primary",
                  fill: "#1657E2"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M36.0042324,50.4000008 C36.9876399,50.4000008 37.7848491,51.19721 37.7848491,52.1806174 L37.7839476,66.7690008 L45.9989598,55.5652127 C46.5758864,54.7782711 47.6790917,54.6030418 48.4714624,55.1724889 C49.2542012,55.7350139 49.4327198,56.8255657 48.8701948,57.6083045 C48.8669789,57.6127792 48.863742,57.6172387 48.8604839,57.6216827 L37.8802828,72.5989369 L37.7839476,72.7180008 L37.7848491,107.902473 C37.7848491,108.88588 36.9876399,109.68309 36.0042324,109.68309 C35.020825,109.68309 34.2236158,108.88588 34.2236158,107.902473 L34.2234737,76.67434 C34.1835658,76.6411505 34.144767,76.6059469 34.1072121,76.5687294 L24.117685,66.6689473 C23.4330747,65.9904874 23.4280887,64.8855008 24.1065485,64.2008904 L24.1188449,64.1886056 L24.1188449,64.1886056 C24.8129583,63.5020136 25.930543,63.5025363 26.6240139,64.1897771 L34.2229476,71.7200008 L34.2236158,52.1806174 C34.2236158,51.19721 35.020825,50.4000008 36.0042324,50.4000008 Z",
                  id: "Combined-Shape-Copy-4",
                  fill: "#091E43"
                })]
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              id: "sun",
              transform: "translate(268.800004, 24.800000)",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
                id: "Sol",
                className: "fill-secondary",
                fill: "#10105A",
                fillRule: "nonzero",
                cx: "238.000004",
                cy: "63.2000009",
                r: "35.6000005"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                d: "M139.346344,0 C153.845839,0 165.600002,11.730095 165.600002,26.1999005 C165.600002,26.669493 165.587623,27.1362 165.563171,27.5997142 L82.812493,27.5991047 C82.8041878,27.3576551 82.8000012,27.1151618 82.8000012,26.8716928 C82.8000012,15.3700525 92.1430543,6.04613087 103.668294,6.04613087 C109.053169,6.04613087 113.961676,8.08153157 117.663444,11.4234592 C122.391718,4.52643278 130.339344,0 139.346344,0 Z",
                id: "Combined-Shape-Copy-7",
                fill: "#FFFFFF"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                d: "M294.546346,38.4000006 C309.045841,38.4000006 320.800005,50.1300956 320.800005,64.599901 C320.800005,65.0694935 320.787625,65.5362006 320.763174,65.9997148 L238.012495,65.9991053 C238.00419,65.7576557 238.000004,65.5151624 238.000004,65.2716933 C238.000004,53.7700531 247.343057,44.4461314 258.868297,44.4461314 C264.253172,44.4461314 269.161678,46.4815321 272.863446,49.8234598 C277.59172,42.9264334 285.539346,38.4000006 294.546346,38.4000006 Z",
                id: "Combined-Shape-Copy-8",
                fill: "#FFFFFF",
                transform: "translate(279.400004, 52.199858) scale(-1, 1) translate(-279.400004, -52.199858) "
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                d: "M56.5463423,66.000001 C71.0458378,66.000001 82.8000012,77.730096 82.8000012,92.1999014 C82.8000012,92.669494 82.7876216,93.136201 82.7631702,93.5997152 L0.0124917427,93.5991057 C0.00418655527,93.3576561 1.42108547e-14,93.1151628 1.42108547e-14,92.8716938 C1.42108547e-14,81.3700535 9.34305302,72.0461319 20.868293,72.0461319 C26.253168,72.0461319 31.1616743,74.0815326 34.8634425,77.4234602 C39.5917165,70.5264338 47.5393423,66.000001 56.5463423,66.000001 Z",
                id: "Combined-Shape-Copy-9",
                fill: "#FFFFFF",
                transform: "translate(41.400001, 79.799858) scale(-1, 1) translate(-41.400001, -79.799858) "
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              id: "Group-4",
              transform: "translate(99.000003, 253.000003) scale(-1, 1) translate(-99.000003, -253.000003) translate(12.000003, 216.000003)",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                d: "M60.7892009,73.6000011 L100.011201,73.6000011 L173.818803,73.6000011 C173.935203,72.5488011 174.000003,71.4820011 174.000003,70.400001 C174.000003,54.4940008 161.106002,41.6000006 145.2,41.6000006 C143.890002,41.6000006 142.602402,41.6956006 141.338802,41.8652006 C138.526802,28.9080004 126.999602,19.2000003 113.2,19.2000003 C105.779602,19.2000003 99.0156015,22.0084003 93.9096014,26.6180004 C92.7932014,11.7324002 80.3708012,0 65.2000001,0 C49.8168007,0 37.2524006,12.0612002 36.4432005,27.2428004 C21.2616003,28.0520004 9.20000014,40.6168006 9.20000014,56 C9.20000014,62.6300009 11.4464002,68.732001 15.2112002,73.6000011 L60.7892009,73.6000011 Z",
                id: "Fill-1",
                className: "fill-primary-opa50",
                fill: "#779DED"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                d: "M39.5684161,73.6000011 L69.6513098,73.6000011 L126.261023,73.6000011 C126.350301,72.794462 126.400002,71.9769685 126.400002,71.1478271 C126.400002,58.95899 116.510429,49.0782616 104.310681,49.0782616 C103.305924,49.0782616 102.318347,49.1515203 101.349178,49.2814855 C99.1924015,39.3523267 90.3511509,31.913044 79.7669915,31.913044 C74.0756166,31.913044 68.8876942,34.0651331 64.9714417,37.5974897 C64.1151738,26.1905895 54.5873134,17.2000003 42.951457,17.2000003 C31.1526917,17.2000003 21.5159188,26.4425504 20.8952702,38.0762767 C9.25113023,38.6963701 0,48.3248312 0,60.1130444 C0,65.1936423 1.72296702,69.8696315 4.61053211,73.6000011 L39.5684161,73.6000011 Z",
                id: "Fill-1-Copy",
                className: "fill-primary",
                fill: "#1657E2"
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              id: "Group-4-Copy",
              transform: "translate(530.000008, 216.000003)",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                d: "M60.7892009,73.6000011 L100.011201,73.6000011 L173.818803,73.6000011 C173.935203,72.5488011 174.000003,71.4820011 174.000003,70.400001 C174.000003,54.4940008 161.106002,41.6000006 145.2,41.6000006 C143.890002,41.6000006 142.602402,41.6956006 141.338802,41.8652006 C138.526802,28.9080004 126.999602,19.2000003 113.2,19.2000003 C105.779602,19.2000003 99.0156015,22.0084003 93.9096014,26.6180004 C92.7932014,11.7324002 80.3708012,0 65.2000001,0 C49.8168007,0 37.2524006,12.0612002 36.4432005,27.2428004 C21.2616003,28.0520004 9.20000014,40.6168006 9.20000014,56 C9.20000014,62.6300009 11.4464002,68.732001 15.2112002,73.6000011 L60.7892009,73.6000011 Z",
                id: "Fill-1",
                className: "fill-primary-opa50",
                fill: "#779DED"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                d: "M39.5684161,73.6000011 L69.6513098,73.6000011 L126.261023,73.6000011 C126.350301,72.794462 126.400002,71.9769685 126.400002,71.1478271 C126.400002,58.95899 116.510429,49.0782616 104.310681,49.0782616 C103.305924,49.0782616 102.318347,49.1515203 101.349178,49.2814855 C99.1924015,39.3523267 90.3511509,31.913044 79.7669915,31.913044 C74.0756166,31.913044 68.8876942,34.0651331 64.9714417,37.5974897 C64.1151738,26.1905895 54.5873134,17.2000003 42.951457,17.2000003 C31.1526917,17.2000003 21.5159188,26.4425504 20.8952702,38.0762767 C9.25113023,38.6963701 0,48.3248312 0,60.1130444 C0,65.1936423 1.72296702,69.8696315 4.61053211,73.6000011 L39.5684161,73.6000011 Z",
                id: "Fill-1-Copy",
                className: "fill-primary",
                fill: "#1657E2"
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
              id: "Rectangle",
              className: "fill-secondary",
              fill: "#10105A",
              fillRule: "nonzero",
              x: "0",
              y: "289.600004",
              width: "720.000011",
              height: "7.20000011",
              rx: "3.60000005"
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
            id: "house",
            transform: "translate(90.400001, 145.600002)",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-8",
              fill: "#EAEAEA",
              points: "499.388287 54.4000008 451.199887 3.20000005 265.599884 3.20000005 220.799883 57.6000009 281.599884 57.6000009 281.599884 144.000002 502.399887 144.000002 502.399887 54.4000008"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-9",
              fill: "#BA947F",
              points: "316.800005 144.000002 505.600008 144.000002 505.600008 137.600002 316.800005 137.600002"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-10",
              fill: "#66493D",
              points: "211.200003 144.000002 316.800005 144.000002 316.800005 137.600002 211.200003 137.600002"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-11",
              fill: "#BA947F",
              points: "499.200007 137.600002 505.600008 137.600002 505.600008 60.8000009 499.200007 60.8000009"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-12",
              fill: "#66493D",
              points: "492.800007 137.600002 499.200007 137.600002 499.200007 60.8000009 492.800007 60.8000009"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-14",
              fill: "#66493D",
              points: "211.200003 137.600002 217.600003 137.600002 217.600003 60.8000009 211.200003 60.8000009"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-15",
              fill: "#BA947F",
              points: "217.600003 137.600002 224.000003 137.600002 224.000003 60.8000009 217.600003 60.8000009"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-16",
              fill: "#66493D",
              points: "310.400005 137.600002 316.800005 137.600002 316.800005 60.8000009 310.400005 60.8000009"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-17",
              fill: "#BA947F",
              points: "451.200007 137.600002 457.600007 137.600002 457.600007 60.8000009 451.200007 60.8000009"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-18",
              fill: "#66493D",
              points: "444.800007 137.600002 451.200007 137.600002 451.200007 60.8000009 444.800007 60.8000009"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-19",
              fill: "#BA947F",
              points: "473.600007 137.600002 480.000007 137.600002 480.000007 60.8000009 473.600007 60.8000009"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-20",
              fill: "#66493D",
              points: "467.200007 137.600002 473.600007 137.600002 473.600007 60.8000009 467.200007 60.8000009"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-21",
              fill: "#BA947F",
              points: "454.400007 89.6000013 476.800007 89.6000013 476.800007 83.2000012 454.400007 83.2000012"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-22",
              fill: "#BA947F",
              points: "454.400007 121.600002 476.800007 121.600002 476.800007 115.200002 454.400007 115.200002"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-23",
              fill: "#BA947F",
              points: "342.400005 137.600002 348.800005 137.600002 348.800005 60.8000009 342.400005 60.8000009"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-24",
              fill: "#66493D",
              points: "336.000005 137.600002 342.400005 137.600002 342.400005 60.8000009 336.000005 60.8000009"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-25",
              fill: "#BA947F",
              points: "364.800005 137.600002 371.200006 137.600002 371.200006 60.8000009 364.800005 60.8000009"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-26",
              fill: "#66493D",
              points: "358.400005 137.600002 364.800005 137.600002 364.800005 60.8000009 358.400005 60.8000009"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-27",
              fill: "#BA947F",
              points: "345.600005 89.6000013 368.000005 89.6000013 368.000005 83.2000012 345.600005 83.2000012"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-28",
              fill: "#BA947F",
              points: "345.600005 121.600002 368.000005 121.600002 368.000005 115.200002 345.600005 115.200002"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-29",
              fill: "#BA947F",
              points: "268.800004 137.600002 275.200004 137.600002 275.200004 60.8000009 268.800004 60.8000009"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-30",
              fill: "#66493D",
              points: "275.200004 137.600002 281.600004 137.600002 281.600004 60.8000009 275.200004 60.8000009"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-31",
              fill: "#BA947F",
              points: "246.400004 137.600002 252.800004 137.600002 252.800004 60.8000009 246.400004 60.8000009"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-32",
              fill: "#66493D",
              points: "252.800004 137.600002 259.200004 137.600002 259.200004 60.8000009 252.800004 60.8000009"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-33",
              fill: "#BA947F",
              points: "249.600004 89.6000013 272.000004 89.6000013 272.000004 83.2000012 249.600004 83.2000012"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-34",
              fill: "#BA947F",
              points: "249.600004 121.600002 272.000004 121.600002 272.000004 115.200002 249.600004 115.200002"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-35",
              fill: "#BA947F",
              points: "425.600006 137.600002 432.000006 137.600002 432.000006 60.8000009 425.600006 60.8000009"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-36",
              fill: "#66493D",
              points: "419.200006 137.600002 425.600006 137.600002 425.600006 60.8000009 419.200006 60.8000009"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-37",
              fill: "#BA947F",
              points: "390.400006 137.600002 396.800006 137.600002 396.800006 60.8000009 390.400006 60.8000009"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-38",
              fill: "#66493D",
              points: "384.000006 137.600002 390.400006 137.600002 390.400006 60.8000009 384.000006 60.8000009"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-39",
              fill: "#BA947F",
              points: "393.600006 89.6000013 428.800006 89.6000013 428.800006 76.8000011 393.600006 76.8000011"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M499.200047,57.5999609 L446.448447,1.55156002 L452.848447,1.55156002 L505.600048,57.5999609 L505.600008,64.000001 L316.800005,64.000001 L316.800005,57.6000009 L499.200047,57.5999609 Z",
              id: "Combined-Shape",
              fill: "#BA947F"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-41",
              fill: "#BA947F",
              points: "448.000007 6.4000001 454.211607 6.4000001 406.400006 57.6000009 400.000006 57.6000009"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-42",
              fill: "#66493D",
              points: "448.000007 3.20000005 444.893607 6.5000001 492.800007 57.6000009 499.200007 57.6000009"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-43",
              fill: "#66493D",
              points: "446.448447 1.55156002 449.554847 4.85156007 400.000046 57.5999609 393.600046 57.5999609"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-44",
              fill: "#BA947F",
              points: "395.248446 1.55156002 388.848446 1.55156002 441.600047 57.5999609 448.000047 57.5999609"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-45",
              fill: "#BA947F",
              points: "390.400006 6.4000001 396.611606 6.4000001 348.800005 57.6000009 342.400005 57.6000009"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-46",
              fill: "#66493D",
              points: "390.400006 3.20000005 387.293606 6.5000001 435.200006 57.6000009 441.600007 57.6000009"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-47",
              fill: "#66493D",
              points: "388.848446 1.55156002 391.954846 4.85156007 342.400045 57.5999609 336.000045 57.5999609"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-48",
              fill: "#BA947F",
              points: "328.048445 1.55156002 321.648445 1.55156002 374.400046 57.5999609 380.800046 57.5999609"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-49",
              fill: "#BA947F",
              points: "323.200005 6.4000001 329.411605 6.4000001 281.600004 57.6000009 275.200004 57.6000009"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-50",
              fill: "#66493D",
              points: "323.200005 3.20000005 320.093605 6.5000001 368.000005 57.6000009 374.400006 57.6000009"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-51",
              fill: "#66493D",
              points: "321.648445 1.55156002 324.754845 4.85156007 275.200044 57.5999609 268.800044 57.5999609"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-52",
              fill: "#BA947F",
              points: "270.448444 1.55156002 264.048444 1.55156002 316.800045 57.5999609 323.200045 57.5999609"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-53",
              fill: "#BA947F",
              points: "265.600004 6.4000001 271.811604 6.4000001 224.000003 57.6000009 217.600003 57.6000009"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-54",
              fill: "#66493D",
              points: "265.600004 3.20000005 262.494004 6.5000001 310.400005 57.6000009 316.800005 57.6000009"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-55",
              fill: "#66493D",
              points: "264.048444 1.55156002 267.154844 4.85156007 217.600043 57.5999609 211.200043 57.5999609"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-57",
              fill: "#66493D",
              points: "211.200003 64.000001 316.800005 64.000001 316.800005 57.6000009 211.200003 57.6000009"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-58",
              fill: "#BA947F",
              points: "457.266007 7.95156012 274.866004 7.95156012 268.800004 1.55156002 451.200007 1.55156002"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-59",
              fill: "#A9A9A9",
              points: "131.200002 144.000002 249.600004 144.000002 249.600004 67.200001 131.200002 67.200001"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-60",
              fill: "#BA947F",
              points: "134.400002 144.000002 323.200005 144.000002 323.200005 137.600002 134.400002 137.600002"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-61",
              fill: "#BA947F",
              points: "134.400002 137.600002 140.800002 137.600002 140.800002 60.8000009 134.400002 60.8000009"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-62",
              fill: "#BA947F",
              points: "160.000002 137.600002 166.400002 137.600002 166.400002 60.8000009 160.000002 60.8000009"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-63",
              fill: "#66493D",
              points: "153.600002 137.600002 160.000002 137.600002 160.000002 60.8000009 153.600002 60.8000009"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-64",
              fill: "#BA947F",
              points: "182.400003 137.600002 188.800003 137.600002 188.800003 60.8000009 182.400003 60.8000009"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-65",
              fill: "#66493D",
              points: "176.000003 137.600002 182.400003 137.600002 182.400003 60.8000009 176.000003 60.8000009"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-66",
              fill: "#BA947F",
              points: "163.200002 89.6000013 185.600003 89.6000013 185.600003 83.2000012 163.200002 83.2000012"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-67",
              fill: "#BA947F",
              points: "163.200002 121.600002 185.600003 121.600002 185.600003 115.200002 163.200002 115.200002"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-68",
              fill: "#BA947F",
              points: "243.200004 137.600002 249.600004 137.600002 249.600004 60.8000009 243.200004 60.8000009"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-69",
              fill: "#66493D",
              points: "236.800004 137.600002 243.200004 137.600002 243.200004 60.8000009 236.800004 60.8000009"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-70",
              fill: "#BA947F",
              points: "208.000003 137.600002 214.400003 137.600002 214.400003 60.8000009 208.000003 60.8000009"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-71",
              fill: "#66493D",
              points: "201.600003 137.600002 208.000003 137.600002 208.000003 60.8000009 201.600003 60.8000009"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-72",
              fill: "#BA947F",
              points: "211.200003 89.6000013 246.400004 89.6000013 246.400004 76.8000011 211.200003 76.8000011"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-73",
              fill: "#091E43",
              points: "134.400002 57.6000009 323.200005 57.6000009 272.000004 0 83.2000012 0"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-74",
              fill: "#C3D0D8",
              points: "83.2000012 0 28.8000004 57.6000009 28.8000004 144.000002 134.400002 144.000002 134.400002 57.6000009"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-75",
              fill: "#FFE168",
              points: "134.400002 73.6000011 208.000003 73.6000011 208.000003 57.6000009 134.400002 57.6000009"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-76",
              fill: "#FFFFFF",
              points: "134.400002 67.200001 134.400002 80.0000012 134.400002 102.400002 160.000002 102.400002 160.000002 80.0000012 230.400003 80.0000012 230.400003 67.200001"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-77",
              fill: "#FFFFFF",
              points: "249.599999 144.000002 323.2 144.000002 323.2 57.6000009 249.599999 57.6000009"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-78-Copy-2",
              fill: "#091E43",
              points: "67.200001 118.400002 96.0000014 118.400002 96.0000014 86.4000013 67.200001 86.4000013"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-79",
              fill: "#C3D0D8",
              points: "134.400002 67.200001 323.200005 67.200001 323.200005 57.6000009 134.400002 57.6000009"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
              id: "Fill-80",
              fill: "#C3D0D8",
              points: "262.400004 64.000001 297.600004 64.000001 313.600005 144.000002 278.400004 144.000002"
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              id: "Group",
              transform: "translate(0.000000, 99.200001)",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                id: "Fill-81",
                fill: "#BA947F",
                points: "12.8000002 44.8000007 16.0000002 44.8000007 16.0000002 32.0000005 12.8000002 32.0000005"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                id: "Fill-82",
                fill: "#BA947F",
                points: "51.2000008 19.2000003 35.2000005 19.2000003 32.0000005 19.2000003 32.0000005 44.8000007 35.2000005 44.8000007 35.2000005 32.0000005 51.2000008 32.0000005 51.2000008 44.8000007 54.4000008 44.8000007 54.4000008 19.2000003"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                id: "Fill-83",
                fill: "#66493D",
                points: "48.0000007 44.8000007 51.2000008 44.8000007 51.2000008 32.0000005 48.0000007 32.0000005"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                id: "Fill-84",
                fill: "#BA947F",
                points: "25.6000004 16.0000002 64.000001 16.0000002 64.000001 9.60000014 25.6000004 9.60000014"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                id: "Fill-85",
                fill: "#66493D",
                points: "32.0000005 16.0000002 28.8000004 16.0000002 25.6000004 16.0000002 25.6000004 9.60000014 0 9.60000014 0 16.0000002 9.60000014 16.0000002 9.60000014 44.8000007 12.8000002 44.8000007 12.8000002 32.0000005 28.8000004 32.0000005 28.8000004 44.8000007 32.0000005 44.8000007 32.0000005 19.2000003 54.4000008 19.2000003 54.4000008 16.0000002"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                d: "M25.6000004,0 C20.2980003,0 16.0000002,4.29800006 16.0000002,9.60000014 L35.2000005,9.60000014 C35.2000005,4.29800006 30.9020005,0 25.6000004,0",
                id: "Fill-86",
                fill: "#FFFFFF"
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              id: "Group-2",
              transform: "translate(265.600004, 44.800001)",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                id: "Fill-87",
                fill: "#BA947F",
                points: "28.8000004 99.2000015 25.6000004 99.2000015 3.20000005 0 6.4000001 0"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                id: "Fill-88",
                fill: "#66493D",
                points: "25.6000004 99.2000015 22.4000003 99.2000015 0 0 3.20000005 0"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                id: "Fill-89",
                fill: "#66493D",
                points: "48.0000007 99.2000015 44.8000007 99.2000015 22.4000003 0 25.6000004 0"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                id: "Fill-90",
                fill: "#BA947F",
                points: "51.2000008 99.2000015 48.0000007 99.2000015 25.6000004 0 28.8000004 0"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                id: "Fill-91",
                fill: "#BA947F",
                points: "22.4000003 80.0000012 44.8000007 80.0000012 44.8000007 73.6000011 22.4000003 73.6000011"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                id: "Fill-92",
                fill: "#BA947F",
                points: "19.2000003 67.200001 41.6000006 67.200001 41.6000006 60.8000009 19.2000003 60.8000009"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                id: "Fill-93",
                fill: "#BA947F",
                points: "16.0000002 54.4000008 38.4000006 54.4000008 38.4000006 48.0000007 16.0000002 48.0000007"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                id: "Fill-94",
                fill: "#BA947F",
                points: "12.8000002 41.6000006 35.2000005 41.6000006 35.2000005 35.2000005 12.8000002 35.2000005"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                id: "Fill-95",
                fill: "#BA947F",
                points: "35.2000005 28.8000004 12.8000002 28.8000004 9.60000014 22.4000003 32.0000005 22.4000003"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                id: "Fill-96",
                fill: "#BA947F",
                points: "32.0000005 16.0000002 9.60000014 16.0000002 6.4000001 9.60000014 28.8000004 9.60000014"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
                id: "Fill-97",
                fill: "#BA947F",
                points: "25.6000004 92.8000014 48.0000007 92.8000014 48.0000007 86.4000013 25.6000004 86.4000013"
              })]
            })]
          })]
        })
      })
    })
  });
};
var _default = exports.default = (0, _withIllustration.default)('IllustrationError')(IllustrationError);